import { makeStyles } from 'tss-react/mui';
import { useCallback } from 'react';
import Check from '@mui/icons-material/Check';
import Sort from '@mui/icons-material/Sort';
import SortByAlpha from '@mui/icons-material/SortByAlpha';
import {
  IconButton, ListItemIcon, ListItemText, MenuItem, Tooltip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import BasicMenu from '../atoms/BasicMenu';

const useStyles = makeStyles()({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export interface SortByMenuProps {
  options: { label: string; key: any }[];
  selectedOption?: any;
  ascending?: boolean;
  disabled?: boolean;
  onSelectedOptionChange: (key: any) => void;
  onAscendingChange: (asc: boolean) => void;
}

const SortByMenu = ({
  options,
  ascending,
  disabled = false,
  selectedOption,
  onSelectedOptionChange,
  onAscendingChange,
}: SortByMenuProps): JSX.Element => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const renderOption = useCallback(
    (option: { label: string; key: any }) => (
      <MenuItem key={option.key} onClick={() => onSelectedOptionChange(option.key)}>
        {option.key === selectedOption ? (
          <>
            <ListItemIcon>
              <Check />
            </ListItemIcon>
            {option.label}
          </>
        ) : (
          <ListItemText inset>{option.label}</ListItemText>
        )}
      </MenuItem>
    ),
    [onSelectedOptionChange],
  );

  return (
    <div className={classes.container}>
      <BasicMenu
        id="sort-by-menu"
        icon={<SortByAlpha />}
        tooltip={t('home.songbook.sortby.sort_by')}
        disabled={disabled}
      >
        {options.map((o) => renderOption(o))}
      </BasicMenu>

      <Tooltip
        title={
          ascending ? t('home.songbook.sortby.ascending') : t('home.songbook.sortby.descending')
        }
      >
        <IconButton onClick={() => onAscendingChange(!ascending)} disabled={disabled}>
          <Sort
            style={{
              transform: `scale(1, ${ascending ? -1 : 1})`,
            }}
          />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default SortByMenu;
